import React from 'react'

import { getLayersHandbook } from 'services/apiRequests'

import { useDispatch } from 'react-redux'
import { setDirectoryItems, setId, setVersionId } from 'store/directorySlice'

const useGetLayers = (requestData: boolean | undefined) => {
  const dispatch = useDispatch()

  const tryToGetLayers = async () => {
    await getLayersHandbook().then((res) => {
      dispatch(setId(res.data.id))
      dispatch(setVersionId(res.data.id))
      dispatch(
        setDirectoryItems(
          res.data.units.map((unit) => {
            return {
              ...unit,
              modified: false,
            }
          }),
        ),
      )
    })
  }

  React.useEffect(() => {
    tryToGetLayers().then()
  }, [requestData])

  return
}

export default useGetLayers
